/**
 * Wraps a value in an array if it isn't already one.
 * @param {*} value
 * @returns {Array}
 */
export function ensureArray(value) {
  if (!Array.isArray(value)) {
    value = [value];
  }
  return value;
}
